import { AccountFacade } from "./account.facade";

export { AccountFacade };

export default [AccountFacade];
